]<!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div
        class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base"
      >
        <h1 class="mb-1 text-white">Veelgestelde vragen</h1>
        <vs-input
          placeholder="Zoeken"
          v-model="faqSearchQuery"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          class="w-full mt-6"
          icon-no-border
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
        <vx-card>
          <h4>Inhoudsopgave</h4>
          <ul class="faq-topics mt-4">
            <li
              v-for="category in categories"
              :key="category.id"
              class="p-2 font-medium flex items-center"
              @click="faqFilter = category.id"
            >
              <div
                class="h-3 w-3 rounded-full mr-2"
                :class="'bg-' + category.color"
              ></div>
              <span class="cursor-pointer">{{ category.name }}</span>
            </li>
          </ul>
        </vx-card>
      </div>

      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <vs-collapse type="margin" class="p-0">
          <vs-collapse-item
            v-for="(que, index) in filteredFaq"
            class="faq-bg rounded-lg"
            :class="{ 'mt-0': !index }"
            :key="que.id"
            :open="que.open"
          >
            <div slot="header">
              <h5>{{ que.question }}</h5>
            </div>
            <div v-html="que.ans"></div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqSearchQuery: "",
      faqFilter: 1,
      categories: [
        {
          id: 1,
          name: "Alles",
          color: "primary"
        },
        {
          id: 2,
          name: "Algemeen",
          color: "primary"
        },
        {
          id: 3,
          name: "Verbruik",
          color: "primary"
        }
      ],
      faqs: [
        {
          id: 1,
          categoryId: 2,
          question: "Wat is de verwerkingstijd van mijn aanpassing?",
          ans: "We verwerken aanvragen binnen vijf werkdagen."
        },
        {
          id: 2,
          categoryId: 3,
          question: "Waarom kan ik mijn verbruik niet inzien?",
          ans:
            "<p>Je hebt een slimme meter nodig om je verbruik in te zien. Daarnaast dien je de groene schakelaar op de verbruik-pagina aan te zetten. Vanaf dat moment zullen we elke dag jouw meterstanden opvragen. Van uur tot uur kan je daarna inzien hoeveel je verbruik is. Elk moment kan je de schakelaar weer aan en uit zetten.</p> "
        },
        {
          id: 3,
          categoryId: 2,
          question:
            "Ik heb suggesties of tips om Mijn Naked Energy te verbeteren",
          ans:
            "<p>Wij doen hard ons best om Mijn Naked Energy voor je te verbeteren. Suggesties, tips of verbeteringen zijn dus altijd welkom. Mocht je dit willen delen met ons, dan kan je een mail sturen naar: service@naked-energy.nl. Wij zullen je tip dan meenemen in onze ontwikkelplannen.</p> "
        }
      ]
    };
  },
  computed: {
    filteredFaq() {
      let result = this.faqs.filter(faq => {
        if (this.faqFilter == 1)
          return (
            faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
            faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          );
        else if (this.faqFilter == 2)
          return (
            faq.categoryId == 2 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 3)
          return (
            faq.categoryId == 3 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 4)
          return (
            faq.categoryId == 4 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 5)
          return (
            faq.categoryId == 5 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
      });
      result.forEach(element => {
        element.open = true;
      });
      return result;
    }
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss">
#faq-page {
  .faq-jumbotron-content {
    background-image: url("../assets/images/pages/faq.jpg");
    background-size: cover;
  }

  .faq-bg {
    background-color: #fff;
  }
}
</style>
